module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC08_ua.a0be20ff.webp";